import { forwardRef, type InputHTMLAttributes } from "react";

const TextInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function TextInput({ className = "", ...rest }, ref) {
    return <input ref={ref} className={`bo-input ${className}`} {...rest} />;
  },
);

export default TextInput;
